/**
 *  @class
 *  @function IngredientBanner
 */

if (!customElements.get("ingredient-banner")) {
  class IngredientBanner extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (
        document.body.classList.contains("animations-true") &&
        typeof gsap !== "undefined"
      ) {
        this.prepareAnimations();
      }
    }
    prepareAnimations() {
      let property = () => {
        return gsap.getProperty("html", "--header-height", "px");
      };

      const gridItems = document.querySelectorAll(
        ".ib-item:not([data-type='main'])",
      );
      const container = document.querySelector(".ingredient-banner__container");

      // Store original positions
      const originalPositions = [];

      gridItems.forEach((item) => {
        const rect = item.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        let relative_top = rect.top - containerRect.top;

        originalPositions.push({
          x:
            rect.width / 2 -
            containerRect.width / 2 +
            rect.left -
            containerRect.left,
          y: relative_top + rect.height / 2 - containerRect.height / 2,
        });
      });

      // Set items to absolute positioning for animation
      gridItems.forEach((item) => {
        item.style.position = "absolute";
        item.style.top = "50%";
        item.style.left = "50%";
        item.style.transform = "translate(-50%, -50%)";
      });

      // Animate items to their natural positions
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          scrub: false,
          start: () => `top 50%`,
          end: () => `bottom top+=${property()}`,
          markers: false,
          toggleActions: "play none none none", // dont understand this (LOL)
        },
      });

      tl.to(
        gridItems,
        {
          x: (i) => originalPositions[i].x,
          y: (i) => originalPositions[i].y,
          opacity: 1,
          duration: 1.5,
          stagger: 0.1,
          ease: "power2.out",
          onComplete: function () {
            // Revert items to grid positioning
            gridItems.forEach((item) => {
              item.style.position = "";
              item.style.top = "";
              item.style.left = "";
              item.style.transform = "";
              item.style.opacity = "1";
            });
          },
        },
        "-=25%",
      );
    }
  }
  customElements.define("ingredient-banner", IngredientBanner);
}
